import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

const EqualNot: IconNode = [
  'svg',
  defaultAttributes,
  [
    ['line', { x1: '5', x2: '19', y1: '9', y2: '9' }],
    ['line', { x1: '5', x2: '19', y1: '15', y2: '15' }],
    ['line', { x1: '19', x2: '5', y1: '5', y2: '19' }],
  ],
];

export default EqualNot;
